import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { BookOpen } from 'lucide-react';
const NAMES = ['María', 'Carolina', 'Gabriela', 'Lucía', 'Andrea', 'Fernanda', 'Soledad', 'Romina', 'Daniela', 'Patricia', 'Alejandra', 'Verónica', 'Natalia', 'Silvana', 'Lorena'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Neuquén', 'Bahía Blanca', 'Resistencia', 'Posadas', 'San Luis', 'Corrientes', 'Formosa', 'Jujuy', 'Catamarca', 'La Rioja', 'Santiago del Estero', 'Entre Ríos', 'Misiones', 'Chaco', 'Río Negro', 'Chubut', 'Santa Cruz', 'Tierra del Fuego'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentName, setCurrentName] = useState('');
  const [currentCity, setCurrentCity] = useState('');
  useEffect(() => {
    const showPopup = () => {
      // Pick random name and city
      setCurrentName(NAMES[Math.floor(Math.random() * NAMES.length)]);
      setCurrentCity(CITIES[Math.floor(Math.random() * CITIES.length)]);
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Initial delay before first popup
    const initialTimeout = setTimeout(() => {
      showPopup();
      // Then set interval for subsequent popups (every 8-15 seconds)
      const interval = setInterval(() => {
        showPopup();
      }, Math.floor(Math.random() * (15000 - 8000 + 1) + 8000));
      return () => clearInterval(interval);
    }, 5000);
    return () => clearTimeout(initialTimeout);
  }, []);
  return <AnimatePresence data-id="element-323">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-4 left-4 z-50 bg-white rounded-xl shadow-2xl border border-slate-100 p-4 max-w-xs flex items-center gap-4" data-id="element-324">
          <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-325">
            <BookOpen className="w-6 h-6 text-[#16A34A]" data-id="element-326" />
          </div>
          <div data-id="element-327">
            <p className="text-sm text-slate-800 font-medium leading-tight" data-id="element-328">
              <span className="font-bold" data-id="element-329">{currentName}</span> de {currentCity}{' '}
              acaba de comprar el Mega Pack 📚
            </p>
            <p className="text-xs text-slate-500 mt-1" data-id="element-330">Hace unos instantes</p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}